<div 
    class="demooz_input_picture"
    [class.disabled]="this.disabled"
    >
        
    <input 
        #demoozInputFile
        type="file"      
        [name]="this.formName" 
        [formControlName]="this.formName"
        [accept]="this.getAcceptFiles()"
        (change)="this.onChangeFile($event)"        
        />   
    
    <div class="demooz_input_picture_preview" (click)="this.selectFile()">     
        @if(this.file && this.file.objectUrl){
            <img [src]="this.file.objectUrl" />
        }   
        @else if(this.file && this.file.urlImage){
            <img [src]="this.file.urlImage" />            
        }   
        @else{            
            {{this.altValue}}
        }
    </div>
    <div class="demooz_input_picture_actions">
        <div class="demooz_input_picture_label">
            @if(this.iconInput !== ''){
                <ion-icon class="demooz_input_picture_icon_prefix" [name]="this.iconInput"></ion-icon>
            }
            @if(this.isRequired){
            <div class="demooz_input_picture_required">*</div>
            }
            {{this.labelInput}}
        </div>
        <div class="demooz_input_picture_indication">{{this.indicationInput}}</div>
        @if(!this.disabled){
            <div class="demooz_input_picture_buttons">            
                <demooz-button type="button" label="{{'INPUT_PICTURE.SELECT_PICTURE' | translate}}" size="small" (click)="this.selectFile()"/> 
                @if(this.showBtnClearInput){
                    <demooz-button type="button" label="{{'INPUT_PICTURE.RESET' | translate}}" color="secondary" size="small" (click)="this.clearInput($event)"/> 
                }
            </div>
        }
    </div>
</div>

<ion-modal #modalCropPicture   
    class="demooz_modal_crop_picture"
    [canDismiss]="this.canDismissCropPictureModal.bind(this)"
    (didDismiss)="this.onDidDismissCropPictureModal($event)" 
    >
    <ng-template>        
        <ion-content>
            <div class="image_cropper_content">
                
                @if(this.isFetchingPicture){
                    <div class="bloc_loading">
                        <ion-spinner></ion-spinner>
                    </div>   
                }
                
                <image-cropper      
                    [class.hide_cropper]="this.isFetchingPicture"
                    [imageChangedEvent]="this.imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [aspectRatio]="1"
                    format="jpeg"
                    [autoCrop]="true"
                    [cropperMinWidth]="150"
                    [cropperMinHeight]="150"
                    (imageCropped)="this.imageCropped($event)"
                    (imageLoaded)="this.imageLoaded($event)"
                    (cropperReady)="this.cropperReady()"
                    (loadImageFailed)="this.loadImageFailed()"
                ></image-cropper>     
            </div>
        </ion-content>
        <ion-footer>
            <ion-toolbar>                
                <ion-grid class="no_padding">
                    <ion-row class="ion-justify-content-around">        
                        <ion-col size="auto">
                            <demooz-button type="button" label="{{'MAIN.CANCEL' | translate}}" color="secondary" (click)="this.cancelPicture()"/> 
                        </ion-col>
                        <ion-col size="auto">
                            <demooz-button type="button" label="{{'MAIN.VALIDATE' | translate}}" (click)="this.validatePicture()"/> 
                        </ion-col>                        
                    </ion-row>
                </ion-grid>                
            </ion-toolbar>
        </ion-footer>
    </ng-template>
</ion-modal>